import { OfflineState } from '@/state/offline-management'
import { Tooltip } from 'antd'

export default function RealNetworkStatus() {
  const isCurrentlyConnected = OfflineState.existNetworkConnection.value
  const isOnline = OfflineState.isOnline.value

  if (isOnline) return null

  if (isCurrentlyConnected) {
    return (
      <Tooltip title='Con acceso a internet' placement='left'>
        <div className='real-network active' />
      </Tooltip>
    )
  }

  return (
    <Tooltip title='Sin acceso a internet' placement='left'>
      <div className='real-network inactive' />
    </Tooltip>
  )
}
